document.addEventListener('DOMContentLoaded', function() {
  function flavia(w, h, amp, wl) {
    function nHalf(len) {
      var n = Math.round(len / (wl / 2));
      if (n < 2) n = 2;
      if (n % 2 === 0) n++;
      return n;
    }
    var nhx = nHalf(w), shx = w / nhx, chx = shx * 0.36 * 2;
    var nhy = nHalf(h), shy = h / nhy, chy = shy * 0.36 * 2;
    var d = 'M 0 0 ';
    for (var i = 0; i < nhx; i++) {
      var x0 = i * shx, x1 = x0 + shx;
      var peak = (i % 2 === 0) ? -amp : amp;
      d += 'C '+(x0+chx*0.5)+' '+peak+' '+(x1-chx*0.5)+' '+peak+' '+x1+' 0 ';
    }
    for (var i = 0; i < nhy; i++) {
      var y0 = i * shy, y1 = y0 + shy;
      var peak = (i % 2 === 0) ? (w+amp) : (w-amp);
      d += 'C '+peak+' '+(y0+chy*0.5)+' '+peak+' '+(y1-chy*0.5)+' '+w+' '+y1+' ';
    }
    for (var i = nhx - 1; i >= 0; i--) {
      var x0 = i * shx, x1 = x0 + shx;
      var peak = (i % 2 === 0) ? (h+amp) : (h-amp);
      d += 'C '+(x1-chx*0.5)+' '+peak+' '+(x0+chx*0.5)+' '+peak+' '+x0+' '+h+' ';
    }
    for (var i = nhy - 1; i >= 0; i--) {
      var y0 = i * shy, y1 = y0 + shy;
      var peak = (i % 2 === 0) ? -amp : amp;
      d += 'C '+peak+' '+(y1-chy*0.5)+' '+peak+' '+(y0+chy*0.5)+' 0 '+y0+' ';
    }
    return d + 'Z';
  }

  function applyFlavia(el, amp, wl) {
    if (el.classList.contains('am-wave-done')) return;
    el.classList.add('am-wave-done');
    var bgColor = getComputedStyle(el).backgroundColor;
    var textColor = getComputedStyle(el).color;
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('am-wave-svg');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('fill', bgColor);
    path.setAttribute('stroke', 'none');
    svg.appendChild(path);
    el.style.color = textColor;
    el.insertBefore(svg, el.firstChild);
    Array.from(el.childNodes).forEach(function(n) {
      if (n === svg) return;
      if (n.nodeType === 3 && n.textContent.trim()) {
        var span = document.createElement('span');
        span.style.cssText = 'position:relative;z-index:2;';
        span.textContent = n.textContent;
        el.replaceChild(span, n);
      } else if (n.nodeType === 1) {
        n.style.position = 'relative';
        n.style.zIndex = '2';
      }
    });
    function draw() {
      var w = el.offsetWidth, h = el.offsetHeight;
      if (!w || !h) return;
      var pad = amp + 4;
      svg.setAttribute('viewBox', (-pad)+' '+(-pad)+' '+(w+pad*2)+' '+(h+pad*2));
      svg.setAttribute('width', (w+pad*2));
      svg.setAttribute('height', (h+pad*2));
      path.setAttribute('d', flavia(w, h, amp, wl));
    }
    draw();
    window.addEventListener('resize', draw);
  }

  // Botones
  var btnSel = '.button:not(.add-to-cart-button):not(.button-unstyled):not(.close-button):not(.button-shopify-xr):not(.quantity-minus):not(.quantity-plus), button.shopify-payment-button__button--unbranded';
  document.querySelectorAll(btnSel).forEach(function(el) { applyFlavia(el, 6, 60); });

  // Badges
  var badgeSel = '.product-badges__badge';
  document.querySelectorAll(badgeSel).forEach(function(el) { applyFlavia(el, 4, 20); });

  new MutationObserver(function(ms) {
    ms.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(btnSel)) applyFlavia(node, 6, 60);
        if (node.querySelectorAll) {
          node.querySelectorAll(btnSel).forEach(function(el) { applyFlavia(el, 6, 60); });
          node.querySelectorAll(badgeSel).forEach(function(el) { applyFlavia(el, 4, 20); });
        }
        if (node.matches && node.matches(badgeSel)) applyFlavia(node, 4, 20);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
